import gql from 'graphql-tag';

export default gql`
  fragment prospectPoolUserDailyReportTelStatusCountFragment on ProspectPoolUserDailyReportTelStatusCount {
    clientProspectTelStatusId
    count
  }
`;
